import React from 'react';

export default function CutsHeader({ children }) {
  return (
    <section className="section section--lg cuts-header">
      <div className="cuts-header__left-side">
        <h3 className="montserrat-bold">View the Primal Cuts</h3>
        <p>
          No matter your budget or the occasion, there is a beef cut to fit your
          family's needs. It's easy to bring a delicious, balanced beef meal to
          your family any day of the week.
        </p>
        <a href="/cuts/beef-quality-grades" className="btn btn--lg btn--block">
          Learn More about Beef Quality Grades
        </a>
      </div>
      {children}
    </section>
  );
}
